module.exports = "<div class=\"wrapper\">\n    <router-outlet name=\"sidebar\"></router-outlet>\n    <router-outlet name=\"content\"></router-outlet>\n</div>"